// extracted by mini-css-extract-plugin
export default {"companyProfile":"CompanyProfile_companyProfile__4Jnf1","content":"CompanyProfile_content__ax-kQ"};